import DashboardView from "./components/dashboard-view";

const Dashboard = () => {
  return <DashboardView />;
};

export default Dashboard;
